import { getProficiencyLabel } from "./assessmentHelpers";
import S from "./Assessments.module.scss";

/** Competency score column */
const CompetencyScore = ({ latestScorePercent, latestTeamAveragePercent }) => {
  const label = getProficiencyLabel(latestScorePercent);
  const score = latestScorePercent != null ? Math.round(latestScorePercent) : null;
  const teamAvg = latestTeamAveragePercent != null ? Math.round(latestTeamAveragePercent) : null;

  return (
    <div className={S.competencyColumn}>
      <span className={S.competencyLabel}>Competency Score</span>
      {label && <span className="atlas-h3">{label}</span>}
      <div className={S.scoreRow}>
        {score != null && (
          <div>
            <span className={S.scoreValue}>{score}%</span>
            <div className={S.scoreLabel}>Your latest score</div>
          </div>
        )}
        {teamAvg != null && (
          <div>
            <span className={S.scoreValue}>{teamAvg}%</span>
            <div className={S.scoreLabel}>Latest team avg</div>
          </div>
        )}
      </div>
    </div>
  );
};

export { CompetencyScore };
